import { createAxiosClient, ServiceProxyMap } from '@atlassian/temp-client-utils';
import { EmailResults, EmailSearchOptions } from '@atlassian/cssxp-types-email';

const client = createAxiosClient({ baseURL: '/api/1/emails' }, ServiceProxyMap.ANS);

export async function searchEmails(search: any, searchOptions: EmailSearchOptions): Promise<EmailResults> {
  const { query } = search;
  const searchOptionsWithDefaults = {
    sort: [{ date: 'desc' }, { id: 'desc' }],
    ...searchOptions,
    query: query,
  };

  const result = await client.get('/', { params: searchOptionsWithDefaults });

  return result.data;
}
